module.exports = __webpack_public_path__ + "img/extended.bcf112d9.png";